import { DualAxisChart } from "./DualAxisChart";
import { SingleAxisChart } from "./SingleAxisChart";

export type SeriesDefinition = {
  name: string;
  color: string;
  dataSet: ChartData[];
};

type ChartData = {
  ts: number;
  value: number | null;
  value2?: number | null;
};

interface ChartProps {
  seriesDefintions: SeriesDefinition[];
  isLoading: boolean;
  alertMessage?: string;
  height?: string;
}

export function Chart({
  seriesDefintions,
  isLoading,
  alertMessage,
  height = "100%",
}: ChartProps) {
  if (seriesDefintions.length === 1) {
    return (
      <SingleAxisChart
        isLoading={isLoading}
        seriesDefintion={seriesDefintions[0]}
        alertMessage={alertMessage}
        height={height}
      />
    );
  } else if (seriesDefintions.length === 2) {
    return (
      <DualAxisChart
        isLoading={isLoading}
        seriesDefintions={seriesDefintions}
        height={height}
      />
    );
  }
  return null;
}

export function getAdaptiveTickFormatter(
  data: ChartData[]
): (ts: number) => string {
  if (!data || data.length === 0) {
    return (ts: number) => formatDate(new Date(ts), "short");
  }

  const minDay = Math.min(...data.map((item) => new Date(item.ts).getTime()));
  const maxDay = Math.max(...data.map((item) => new Date(item.ts).getTime()));
  const days = (maxDay - minDay) / (1000 * 60 * 60 * 24);

  if (days > 90) {
    return (ts: number) => formatDate(new Date(ts), "month");
  } else if (days > 3) {
    return (ts: number) => formatDate(new Date(ts), "short");
  } else {
    return (ts: number) => formatDate(new Date(ts), "time");
  }
}

function formatDate(date: Date, format: "month" | "short" | "time"): string {
  const shortDate = date.toLocaleDateString("de", {
    month: "numeric",
    day: "numeric",
    year: "2-digit",
  });
  const time = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  const month = date.toLocaleString("default", { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear();

  if (format === "month") return `${month} ${year}`;
  else if (format === "time") return `${shortDate} ${time}`;
  return `${day} ${month}`;
}
